import api from '@/services/api';
const ENTITY_ENDPOINT = 'suaje-tipo';

export class SuajeTipoService {
  /**
   * Obtiene todos los tipos de suaje con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los tipos de suaje con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Obtiene un tipo de suaje por su ID
   * @param {string|number} id - ID del tipo de suaje
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo tipo de suaje
   * @param {Object} suajeTipo - Datos del tipo de suaje a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(suajeTipo) {
    return await api.post(`/${ENTITY_ENDPOINT}`, suajeTipo);
  }

  /**
   * Actualiza un tipo de suaje existente
   * @param {string|number} id - ID del tipo de suaje
   * @param {Object} suajeTipo - Datos del tipo de suaje a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, suajeTipo) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, suajeTipo);
  }

  /**
   * Elimina un tipo de suaje
   * @param {string|number} id - ID del tipo de suaje
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default SuajeTipoService;
